import { Module } from 'vuex';

import { FAQItem, FAQList, RootState } from 'frontend/types';

const faqs: Module<FAQList, RootState> = {
  namespaced: true,
  state: {
    faqs: [] as FAQItem[],
  },
  getters: {
    faqItems(state) {
      return state.faqs;
    },
  },
  mutations: {
    setValue(state: FAQList, value: FAQList): void {
      Object.assign(state, value);
    },
  },
  actions: {},
};

export default faqs;
